import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const searchSchema = z.object({
  active: z.boolean().optional(),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});
export const Route = createFileRoute('/_staff/users/$userId/_layout/sessions/')({
  validateSearch: zodValidator(searchSchema)
});